<template>
  <v-card>
    <v-card-title>
      Running tasks
      <v-spacer></v-spacer>
      
    </v-card-title>
    <v-data-table
        v-bind:headers="headers"
        v-bind:items="items"
        hide-actions
      >
      <template slot="items" scope="props">
        <td class="text-xs-right">{{ props.item.project.name }}</td>
        <td class="text-xs-right">{{ props.item.user.name }}</td>
        <td class="text-xs-right"><v-icon  v-if="props.item.billable" color="grey">trending_up</v-icon><v-icon v-if="!props.item.billable" color="grey">trending_flat</v-icon></td>
        <td class="text-xs-right">{{ props.item.notes }}</td>
        <td class="text-xs-right">{{ props.item.hours }}</td>
        <td class="text-xs-right"> <v-progress-circular indeterminate color="grey"></v-progress-circular></td>
      </template>
    </v-data-table>
  </v-card>
</template>




<script>
  export default {
    props:['data'],
    data () {
      return {
        max25chars: (v) => v.length <= 25 || 'Input too long!',
        tmp: '',
        search: '',
        pagination: {
          rowsPerPage:10
        },
        headers: [
          {
            text: 'Project',
            sortable: false,
            value: 'project.name'
          },
          { text: 'User', sortable: false, value: 'user.name' },
          { text: 'Billable', sortable: false, value: 'billable' },
          { text: 'Notes', sortable: false, value: 'notes' },
          { text: 'Hours', sortable: false, value: 'hours' }
        ],
        items: []
      }
    },
    watch:{
        data: function(newValue){
            console.log('newValue')
            this.items =newValue.time_entries;
            this.pagination = {
                page: newValue.page,
                rowsPerPage: newValue.per_page,
                totalItems: newValue.total_entries
            }
          
        }
       
    },
    created(){
        console.log('this.data',this.data)
        console.log('this.data', this.data)
            this.items = this.data.time_entries;
           
    }

  }
</script>


// WEBPACK FOOTER //
// src/components/Admin/Dashboard/Activity/NowActivityTable.vue